import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const DealsIcon: React.FC<Props> = ({ fill = "#008EC6", ...props }) => {
    return (
        <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.9705 2.25261C20.4663 1.74841 19.7081 1.46723 18.9594 1.29529C18.1861 1.11767 17.3008 1.03047 16.4308 0.994368C14.6883 0.922078 12.9078 1.05148 11.9977 1.13511C11.4297 1.1873 10.9053 1.41965 10.4831 1.78252C7.33082 4.49184 4.4611 7.30033 1.71543 10.3668C0.459114 11.7699 0.445789 13.8648 1.57709 15.326C3.44283 17.7357 5.48744 19.7803 7.89712 21.646C9.35825 22.7773 11.4532 22.764 12.8563 21.5077C15.9228 18.762 18.7313 15.8923 21.4406 12.74C21.8035 12.3177 22.0358 11.7933 22.088 11.2254C22.1716 10.3153 22.301 8.5348 22.2287 6.79228C22.1926 5.92228 22.1054 5.03702 21.9278 4.26367C21.7559 3.51505 21.4747 2.75681 20.9705 2.25261ZM10.4961 7.72321C9.94384 7.72321 9.49609 8.17093 9.49609 8.72321C9.49609 9.2755 9.94384 9.72325 10.4961 9.72325H10.511C11.0633 9.72325 11.511 9.2755 11.511 8.72321C11.511 8.17093 11.0633 7.72321 10.511 7.72321H10.4961ZM10.4998 15.7232C9.94754 15.7232 9.4998 16.1709 9.4998 16.7232C9.4998 17.2754 9.94754 17.7232 10.4998 17.7232H10.5147C11.067 17.7232 11.5147 17.2754 11.5147 16.7232C11.5147 16.1709 11.067 15.7232 10.5147 15.7232H10.4998ZM5.5 12.7232C5.5 12.1709 5.94772 11.7232 6.5 11.7232H14.5C15.0522 11.7232 15.5 12.1709 15.5 12.7232C15.5 13.2754 15.0522 13.7232 14.5 13.7232H6.5C5.94772 13.7232 5.5 13.2754 5.5 12.7232ZM17 4.72321C17.8284 4.72321 18.5 5.39478 18.5 6.22321C18.5 7.05164 17.8284 7.72321 17 7.72321C16.1715 7.72321 15.5 7.05164 15.5 6.22321C15.5 5.39478 16.1715 4.72321 17 4.72321Z"
                fill={fill}
            />
        </svg>
    );
};

export default DealsIcon;
